export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            联系我们
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8">
            无论你是漫画作者、汉化组还是热心读者，欢迎通过以下方式与我们取得联系。投稿推荐、版权合作、追更反馈——女神漫画网始终为你敞开大门。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <div className="flex items-center gap-3 px-6 py-3 bg-background-50 rounded-xl border border-background-200/70">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100">
                <i className="ri-mail-line text-lg text-primary-600"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-500">投稿与合作</div>
                <div className="text-sm font-medium text-foreground-800">contact@nvshenmanga.com</div>
              </div>
            </div>
            <div className="flex items-center gap-3 px-6 py-3 bg-background-50 rounded-xl border border-background-200/70">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100">
                <i className="ri-wechat-line text-lg text-accent-600"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-500">读者交流群</div>
                <div className="text-sm font-medium text-foreground-800">扫码加入追更社群</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}